import {Component, Input} from '@angular/core';

@Component({
  selector: 'page-quit-technical',
  templateUrl: 'quit-technical.html',
  styleUrls: ['./quit-technical.scss']
})
export class QuitTechnicalPage {
  @Input() showHeader = true;

  constructor() {
  }

}
